jQuery( document ).ready( function ( $ ) {
	function POPUP( thisInstance ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-popup v2.0' )
		this.instance = thisInstance
		this.init()
	}

	/**
	 * Default actions happening on device actions
	 */
	POPUP.prototype.init = function () {
		const self = this

		const thisId = this.instance.attr( 'data-blockid' )
		const time = this.instance.attr( 'data-timeout' )

		const buttonTriggerId = this.instance.attr( 'data-buttonTriggerId' )
		const buttonTriggerEnable = this.instance.attr( 'data-buttonTriggerEnable' )

		if ( 'false' == buttonTriggerEnable ) {
			setTimeout( function () {
				self.instance.fadeIn()
			}, time )

			if ( localStorage.getItem( thisId ) == 'true' ) {
				self.instance.remove()
			}
		} else {
			document.getElementById( buttonTriggerId )
			.addEventListener(
				"click",
				function ( e ) {
					e.preventDefault()
					self.instance.fadeIn()
				},
			)
		}

		this.instance.find( '.jtf__popupblock--close' ).on( 'click', function () {
			if ( 'false' == buttonTriggerEnable ) {
				self.instance.remove()
				localStorage.setItem( thisId, true )
			} else {
				self.instance.hide()
			}
		} )
	}

	// Check POPUP is used on this page before instantiating
	if ( $( '.wp-block-jtf-jtf-popup' ).length > 0 ) {
		// instantiate a new google maps API for each gmap block
		$( '.wp-block-jtf-jtf-popup' ).each( function () {
			new POPUP( $( this ) )
		} )
	}
} )

